import CoreAPIService from '../../../utils/core-api';
import { fetchAction } from '../../actions';
import { AgentPhone } from '../api-types';
import { push } from 'connected-react-router';
import WindowUtils from '../../../utils/windowUtils';
import UserUtils from '../../../utils/userUtils';
import { paths } from '../../../routes/paths';

export const name: string = 'viaDialog';

export const types = {
    CONNECT_USER: name + '/CONNECT_USER',
    CONNECT_FREE_SEATING_USER: name + '/CONNECT_FREE_SEATING_USER',
    DISCONNECT_FREE_SEATING_USER: name + '/DISCONNECT_FREE_SEATING_USER',
    CALL_PHONE: name + '/CALL_PHONE',
    GET_ALL_PHONES: name + '/GET_ALL_PHONES',
};

interface ViaDialogState {
    phones: AgentPhone[];
}

const initialState: ViaDialogState = {
    phones: [],
};

const reducer = (state = initialState, action): ViaDialogState => {
    const payload = action.payload;
    // const parameters = action.parameters;
    // const id = parameters ? parameters.id : 0;

    switch (action.type) {
        case types.GET_ALL_PHONES:
            return {
                ...state,
                phones: payload,
            };
        default:
            return state;
    }
};
export default reducer;

export const actions = {
    connectUser: (callback?) =>
        fetchAction(CoreAPIService.post(`/core/viadialog/connect`, {}), types.CONNECT_USER, {}, { success: callback }),
    connectFreeSeatingUser: (phoneId: number, callback?) =>
        fetchAction(
            CoreAPIService.post(`/core/viadialog/connectFreeSeating`, { phone_id: phoneId }),
            types.CONNECT_FREE_SEATING_USER,
            {},
            {
                success: (dispatch, response) => {
                    const queryString = window.location.search;
                    const urlParams = new URLSearchParams(queryString);
                    const redirect = urlParams.get('redirect');

                    // console.log('Connection successful', response);
                    if (response?.payload?.access_token) {
                        UserUtils.setFreeSeatingInfos(response.payload);
                        WindowUtils.openViadialog(response.payload?.access_token);
                    }

                    dispatch(push(redirect ?? paths.home));
                },
            },
        ),
    disconnectFreeSeatingUser: (callback?) =>
        fetchAction(
            CoreAPIService.post(`/core/viadialog/disconnectFreeSeating`, {}),
            types.DISCONNECT_FREE_SEATING_USER,
            {},
            {
                success: callback,
                error: (dispatch, error) => {
                    if (error?.payload) {
                        window.alert(
                            `Logout error: ${error.payload.error}.${' Problème lors de la déconnexion. Veuillez réessayer dans quelques instants. Si le problème persiste rendez vous sur la page de login directement (/login)'}`,
                        );
                    }
                },
            },
        ),
    callPhone: (phone, callback?, error?) =>
        fetchAction(
            CoreAPIService.post(`/core/viadialog/call`, { phone }),
            types.CALL_PHONE,
            {},
            { success: callback, error: error },
        ),
    getAllPhones: (callback?) =>
        fetchAction(CoreAPIService.get(`/core/viadialog/phones`), types.GET_ALL_PHONES, {}, { success: callback }),
};

const localState = (state: any): ViaDialogState => state[name] || initialState;
export const selectors = {
    phones: (state) => localState(state).phones,
    availablePhones: (state) => localState(state).phones.filter((phone) => !phone.used),
};
